"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemarketingConsentType = exports.ConsentGroupType = exports.ConsentStatus = exports.ConsentType = exports.ConsentDescriptionFormatType = exports.SegmentType = void 0;
exports.SegmentType = {
    HH: 'household',
    SOHO: 'small_office_home_office',
    SME: 'small_medium_enterprise',
    SPEC: 'special',
    RENT: 'rentals'
};
exports.ConsentDescriptionFormatType = {
    HTML: 'html',
    MARKDOWN: 'markdown'
};
exports.ConsentType = {
    BASIC_INSIGHTS: 'basic_insights',
    OPTIMAL_INSIGHTS: 'optimal_insights',
    FORECASTING_AND_PURCHASING: 'forecasting_and_purchasing',
    RESEARCH_AND_DEVELOPMENT: 'research_and_development',
    ACTIONMAIL: 'actionmail',
    ADVICES_AND_OFFERS_BRAND: 'advices_and_offers_brand',
    ADVICES_AND_OFFERS_SUSTAINABILITY: 'advices_and_offers_sustainability',
    NEWSLETTER: 'newsletter',
    SERVICE_MAILING: 'service_mailing',
    THUISVOORDEEL: 'thuisvoordeel',
    ZAAKVOORDEEL: 'zaakvoordeel',
    TELEMARKETING_ENERGY: 'telemarketing_energy',
    TELEMARKETING_HOME: 'telemarketing_home',
    GOEDZITTERS: 'goedzitters'
};
exports.ConsentStatus = {
    INFORMED: 'informed',
    GIVEN: 'given',
    REVOKED: 'revoked'
};
exports.ConsentGroupType = {
    METERING: 'metering',
    EMAILING: 'emailing',
    TELEMARKETING: 'telemarketing',
    GOEDZITTERS: 'goedzitters'
};
exports.TelemarketingConsentType = {
    TELEMARKETING_ENERGY: 'telemarketing_energy',
    TELEMARKETING_HOME: 'telemarketing_home'
};
